import { useEffect } from 'react';

import { isInvalidLearnLang } from 'src/viewLayer/helpers/validateLearnLang';
import { trackPerformance } from 'src/dataLayer/remoteData/babbelEventStream';
import { LOCALE } from 'src/dataLayer/env';

const usePerformanceTracker = (learnLang: string): void => {
  useEffect(() => {
    if (!performance.timing || isInvalidLearnLang(learnLang)) return;

    // We can't use the spread operator on performance.timing to get its values, since they come from its prototype
    // So we can't create a new object including `locale` and `learnLanguageCode` to pass to 'trackPerformance'
    const performanceData = Object.assign(performance.timing, { LOCALE, learnLang });

    // setTimeout ensures trackPerformance moves to the top of the call stack so we don't wait for the request to finish
    const sendPerformanceTracking = (): ReturnType<typeof setTimeout> => setTimeout(
      () => trackPerformance(performanceData)
    );

    // Wait for the load event if `loadEventEnd` is set to 0
    // eslint-disable-next-line no-unused-expressions
    performanceData.loadEventEnd
      ? sendPerformanceTracking()
      : window.addEventListener('load', sendPerformanceTracking);
  }, [learnLang]);
};

export default usePerformanceTracker;
